import React from "react";

import { ActiveReactionAnimationConsumer } from "../../providers/ActiveReactionAnimationProvider";
import LottiePlayer, {
  LottieAnimation,
  LottiePlayerProps,
} from "./LottiePlayer";

interface OccationalLottieProps extends LottiePlayerProps {
  animation: LottieAnimation;
}

const OccasionalLottie: React.FC<OccationalLottieProps> = ({
  animation,
  ...props
}) => {
  const lottieRef = React.useRef<any>();
  return (
    <ActiveReactionAnimationConsumer>
      {({ shouldAnimate }) => (
        <LottiePlayer
          lottieRef={lottieRef}
          animation={animation}
          loop={true}
          autoplay={shouldAnimate}
          {...props}
        />
      )}
    </ActiveReactionAnimationConsumer>
  );
};

export default OccasionalLottie;
